module.exports = __webpack_public_path__ + "static/media/close.b5f34ab5.svg";